<script setup lang="ts">
const links = useLinks()
const { trackLoginClick, trackCtaClick } = inject(LandingTrackingKey, NOOP_LANDING_TRACKING)
</script>

<template>
    <div class="navbar">
        <SelfAssessmentContainer />
        <nav>
            <div class="navbar__start">
                <UIButton
                    v-bind="links.login.props()"
                    class="navbar__login-button"
                    as="nav"
                    data-test="nav-bar-button-login"
                    @click="trackLoginClick()"
                >
                    <UIIcon
                        name="login"
                    />
                    <span>Log ind</span>
                </UIButton>
            </div>

            <div class="navbar__middle">
                <NuxtLink v-bind="links.signup.props()" @click="trackCtaClick('nav')">
                    <NuxtImg
                        class="navbar__logo"
                        provider="cloudflare"
                        preset="local"
                        src="/media/logo/logo-navbar.png"
                        :width="136"
                        :height="30"
                        :quality="100"
                        alt="Spilnu logo"
                    />
                </NuxtLink>
            </div>
        </nav>
    </div>
</template>

<style scoped lang="scss">
$navy: #0d1a2b;

.navbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-image: linear-gradient(to bottom, $navy 20%, transparent 100%);

    z-index: 10;

    // The page is always navy, whichever theme the visitor has, so the bar matches it
    // instead of the theme background, and fades into the hero with the gradient above.
    :deep(.self-assessment) {
        --self-assessment-border: rgb(255 255 255 / 15%);

        color: #fff;
        background: $navy;
    }

    nav {
        display: grid;
        grid-template-areas: 'start middle end';
        grid-template-columns: 0.5fr 1fr 0.5fr;
        align-items: center;
        padding: 0 15px;
        max-width: 1024px;
        margin: 0 auto;
        box-shadow: unset;
        height: 55px;

        @include tablet {
            height: 70px;
        }

        @include desktop {
            max-width: 1280px;
        }
    }

    &__start {
        grid-area: start;
        display: grid;
        align-items: center;
        justify-items: flex-start;
    }

    &__middle {
        position: relative;
        grid-area: middle;
        display: grid;
        align-items: center;
        justify-items: center;
    }

    &__end {
        grid-area: end;
        display: grid;
        align-items: center;
        justify-items: flex-end;
    }

    &__login-button {
        font-size: $font-size-sm;
        font-weight: $text-semi-bold;
        padding: 10px 10px 10px 0;
        color: var(--login-button-color, #fff);
    }

    &__logo {
        width: 118px;
        height: auto;
        max-height: 45px;

        @include tablet {
            width: 136px;
        }
    }
}
</style>
